import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ConfigurationService } from "../../../../services/configuration.service";
import { CONSTANTS_ASSETS_EMP_WEB_EXP } from "../../../../constants/assets.constants";
import { NsWISConfigurations } from "../../../../models/configurations.model";
import { NsEmpWebExpData } from "../../../../models/emp-web-exp.model";
import * as moment from "moment";

@Component({
  selector: 'mis-employee-web-exp-meal-list-card',
  templateUrl: './meal-list-card.component.html',
  styleUrls: ['./meal-list-card.component.scss']
})
export class MealListCardComponent implements OnInit {

  Assets = CONSTANTS_ASSETS_EMP_WEB_EXP;
  noOfStars: number = 5;
  selectedRating: number = 0;
  mealFeedbackOptions:NsWISConfigurations.IMealFeedBackOptions = {
    improvedOptions : [],
    likedOptions: []
  }; 

  mealFeedBackFormData: NsEmpWebExpData.IMealFeedbackModalInfo;


  @Input() item: any;
  @Input() dateFormat: any;
  @Input() timeFormat: any;
  @Output() action = new EventEmitter();

  constructor(public configSvc: ConfigurationService) {}
  ngOnInit(): void {
    this.configSvc.configurations.subscribe(res => {
      this.mealFeedbackOptions = res?.flattenedSettings?.mealFeedbackOptions;
    });
  }

  ratingSelected(event, item){
    this.selectedRating = event;
    const mealDetails = item.booking.additionalBookings.filter((booking: any) => {
      return booking.premiseType === 'MEALS'
    })
    const mealData = mealDetails[0].extras.mealData.map((meal: any) => ({
      mealId: meal.mealId,
      mealName: meal.name
    }));
    const mealBookingId = mealDetails[0].bookingId;
    this.mealFeedBackFormData = {
      bookingDate: moment(item.time.startTime).tz(item.time.timezone).format('DD/MM/YYYY'),
      bookingId: mealBookingId,
      overallRating: this.selectedRating,
      mealData: mealData,
      mealFeedBackOptions: this.mealFeedbackOptions
    }
    this.action.emit(this.mealFeedBackFormData);
  }

  checkMealRatingStatus(item){
    const filteredData = item.booking.additionalBookings.filter((booking: any) => {
      return booking.premiseType === 'MEALS' && !!booking.extras.mealData && booking.extras.mealData.length > 0 
    });
    return !(!!filteredData[0].extras?.overallRating)
  }

  getMealRating(item){
    const filteredData = item.booking.additionalBookings.filter((booking: any) => {
      return booking.premiseType === 'MEALS' && !!booking.extras.mealData && booking.extras.mealData.length > 0 
    });

    return !!filteredData[0].extras?.overallRating ? filteredData[0].extras?.overallRating : 0;
  }

  

}
